export default {"src":"/_next/static/media/export-factoring.f6d204d4.svg","height":432,"width":552};